import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { AbstractControl, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '../tooltip.directive';

import { faTimes, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { TextareaComponent } from '../textarea/textarea.component';

@Component({
  selector: 'app-form-textarea',
  standalone: true,
  imports: [
    TranslateModule,
    FontAwesomeModule,
    TooltipDirective,
    TextareaComponent
],
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss'],
})
export class FormTextareaComponent {
  @ViewChild('formTextarea')
  formTextarea!: ElementRef<HTMLTextAreaElement>;

  @Input() id?: string;
  @Input() control: FormControl = new FormControl();
  @Input() focus: boolean = false;
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() showRemoveButton: boolean = true;
  @Input() toggleEnabled: boolean = false;
  @Input() expanded: boolean = false;
  @Input() mentionData: string[] = [];

  @Output() toggle = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();

  icons = {
    cancel: faTimes,
    down: faChevronDown,
    up: faChevronUp,
  };

  fc(control: FormControl | AbstractControl): FormControl {
    return control as FormControl;
  }

  removeDescription(): void {
    this.remove.emit();
  }

  onToggle(): void {
    this.toggle.emit();
  }
}
